import ApiClient from '../ApiClient';

const FacebookService = {
  async getPages() {
    const resp = await ApiClient.get('/SocialAuth/facebook/pages');
    return resp.data; 
  },

  async postToPage({ pageId, pageAccessToken, message, imageUrl }) {
  const payload = { pageId, pageAccessToken, message, imageUrl };
  const resp = await ApiClient.post('/SocialAuth/facebook/post', payload, {
    headers: { "Content-Type": "application/json" } // optional
  });
  return resp.data;
},

  async getPagesWithToken(token) {
    const resp = await ApiClient.get('/SocialAuth/facebook/pages', {
      headers: { Authorization: `Bearer ${token}` },
    });
    return resp.data;
  }
};

export default FacebookService;
